// import React from 'react';

// const HomeDashboard = () => {
//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         background: "linear-gradient(135deg, #1e3a5f 0%, #2b6cb0 50%, #1e5799 100%)",
//         position: "relative",
//         overflow: "hidden",
//         padding: "40px 20px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       {/* 🔵 Top Right Glow */}
//       <div
//         style={{
//           position: "absolute",
//           top: "-150px",
//           right: "-150px",
//           width: "450px",
//           height: "450px",
//           borderRadius: "50%",
//           background: "radial-gradient(circle, rgba(43,108,176,0.4) 0%, transparent 70%)",
//           filter: "blur(60px)",
//           pointerEvents: "none",
//         }}
//       />

//       {/* 🔵 Bottom Left Glow */}
//       <div
//         style={{
//           position: "absolute",
//           bottom: "-150px",
//           left: "-150px",
//           width: "400px",
//           height: "400px",
//           borderRadius: "50%",
//           background: "radial-gradient(circle, rgba(30,87,153,0.4) 0%, transparent 70%)",
//           filter: "blur(60px)",
//           pointerEvents: "none",
//         }}
//       />

//       {/* 🔵 Middle Glow */}
//       <div
//         style={{
//           position: "absolute",
//           top: "50%",
//           left: "50%",
//           transform: "translate(-50%, -50%)",
//           width: "600px",
//           height: "600px",
//           borderRadius: "50%",
//           background: "radial-gradient(circle, rgba(255,255,255,0.06) 0%, transparent 70%)",
//           filter: "blur(80px)",
//           pointerEvents: "none",
//         }}
//       />

//       <div
//         style={{
//           width: "100%",
//           maxWidth: "900px",
//           position: "relative",
//           zIndex: 1,
//         }}
//       >
//         <div
//           style={{
//             background: "rgba(255, 255, 255, 0.08)",
//             border: "1.5px solid rgba(255, 255, 255, 0.15)",
//             backdropFilter: "blur(24px)",
//             WebkitBackdropFilter: "blur(24px)",
//             borderRadius: "32px",
//             padding: "80px 50px",
//             textAlign: "center",
//             boxShadow: "0 25px 70px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255,255,255,0.1)",
//             position: "relative",
//             overflow: "hidden",
//           }}
//         >
//           {/* 🎨 Decorative Circle Top Right */}
//           <div
//             style={{
//               position: "absolute",
//               top: "-80px",
//               right: "-80px",
//               width: "220px",
//               height: "220px",
//               borderRadius: "50%",
//               background: "radial-gradient(circle, rgba(43,108,176,0.3) 0%, transparent 70%)",
//               pointerEvents: "none",
//             }}
//           />

//           {/* 🎨 Decorative Circle Bottom Left */}
//           <div
//             style={{
//               position: "absolute",
//               bottom: "-80px",
//               left: "-80px",
//               width: "200px",
//               height: "200px",
//               borderRadius: "50%",
//               background: "radial-gradient(circle, rgba(30,87,153,0.3) 0%, transparent 70%)",
//               pointerEvents: "none",
//             }}
//           />

//           {/* 🎯 Badge */}
//           <div
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               gap: "8px",
//               padding: "10px 24px",
//               borderRadius: "50px",
//               background: "rgba(255, 255, 255, 0.12)",
//               border: "1px solid rgba(255, 255, 255, 0.2)",
//               color: "#ffffff",
//               fontSize: "13px",
//               fontWeight: "700",
//               marginBottom: "35px",
//               letterSpacing: "2px",
//               textTransform: "uppercase",
//               boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
//             }}
//           >
//             <span
//               style={{
//                 width: "8px",
//                 height: "8px",
//                 borderRadius: "50%",
//                 background: "#22c55e",
//                 boxShadow: "0 0 10px rgba(34, 197, 94, 0.8)",
//               }}
//             ></span>
//             Admin Panel
//           </div>

//           {/* 🎯 Welcome Text */}
//           <h1
//             style={{
//               fontSize: "clamp(48px, 8vw, 72px)",
//               fontWeight: "900",
//               color: "#ffffff",
//               marginBottom: "15px",
//               letterSpacing: "-2px",
//               lineHeight: "1.1",
//               textShadow: "0 4px 30px rgba(0, 0, 0, 0.3)",
//             }}
//           >
//             Welcome
//           </h1>

//           {/* 🎯 Subheading */}
//           <h2
//             style={{
//               fontSize: "clamp(22px, 3.5vw, 32px)",
//               fontWeight: "600",
//               color: "rgba(255, 255, 255, 0.95)",
//               marginBottom: "25px",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: "12px",
//             }}
//           >
//             <span>🏠</span> Home Dashboard
//           </h2>

//           {/* 🎯 Divider */}
//           <div
//             style={{
//               width: "80px",
//               height: "4px",
//               background: "linear-gradient(90deg, transparent, #ffffff, transparent)",
//               margin: "0 auto 30px",
//               borderRadius: "10px",
//               opacity: 0.6,
//             }}
//           />

//           {/* 🎯 Description */}
//           <p
//             style={{
//               color: "rgba(255, 255, 255, 0.85)",
//               fontSize: "clamp(14px, 1.6vw, 17px)",
//               lineHeight: "1.7",
//               maxWidth: "650px",
//               margin: "0 auto",
//               fontWeight: "400",
//             }}
//           >
//             Manage analytics, monitor reports and control your complete dashboard
//             experience with a modern, intuitive interface built for real estate professionals.
//           </p>

//           {/* 🎯 Button */}
//           <button
//             style={{
//               marginTop: "40px",
//               border: "none",
//               padding: "16px 40px",
//               borderRadius: "14px",
//               background: "#ffffff",
//               color: "#1e5799",
//               fontWeight: "800",
//               fontSize: "15px",
//               letterSpacing: "0.5px",
//               cursor: "pointer",
//               transition: "all 0.3s ease",
//               boxShadow: "0 12px 35px rgba(0, 0, 0, 0.3)",
//               display: "inline-flex",
//               alignItems: "center",
//               gap: "10px",
//             }}
//             onMouseEnter={(e) => {
//               e.target.style.transform = "translateY(-3px)";
//               e.target.style.boxShadow = "0 18px 45px rgba(0, 0, 0, 0.4)";
//             }}
//             onMouseLeave={(e) => {
//               e.target.style.transform = "translateY(0)";
//               e.target.style.boxShadow = "0 12px 35px rgba(0, 0, 0, 0.3)";
//             }}
//           >
//             Explore Dashboard
//             <span style={{ fontSize: "18px" }}>→</span>
//           </button>

//           {/* 🎯 Bottom Decorative Line */}
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "center",
//               gap: "8px",
//               marginTop: "45px",
//             }}
//           >
//             <div
//               style={{
//                 width: "40px",
//                 height: "4px",
//                 borderRadius: "10px",
//                 background: "#ffffff",
//                 opacity: 0.9,
//               }}
//             ></div>
//             <div
//               style={{
//                 width: "20px",
//                 height: "4px",
//                 borderRadius: "10px",
//                 background: "#ffffff",
//                 opacity: 0.5,
//               }}
//             ></div>
//             <div
//               style={{
//                 width: "10px",
//                 height: "4px",
//                 borderRadius: "10px",
//                 background: "#ffffff",
//                 opacity: 0.3,
//               }}
//             ></div>
//           </div>
//         </div>

//         {/* 🎯 Footer Text */}
//         <p
//           style={{
//             textAlign: "center",
//             color: "rgba(255, 255, 255, 0.6)",
//             fontSize: "13px",
//             marginTop: "30px",
//             letterSpacing: "0.5px",
//           }}
//         >
//           © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All Rights Reserved.
//         </p>
//       </div>
//     </div>
//   );
// };

// export default HomeDashboard;

import React from "react";

const HomeDashboard = () => {
  return (
    <div
      style={{
        height: "100vh",
        width: "100%",
        background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        padding: "16px 20px",
        boxSizing: "border-box",
        fontFamily: "'Poppins', 'DM Sans', sans-serif",
        gap: "14px",
      }}
    >
      {/* 🎯 TOP HEADER */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexShrink: 0,
        }}
      >
        <div>
          <h1
            style={{
              fontSize: "24px",
              fontWeight: "800",
              color: "#1e3a5f",
              margin: 0,
              letterSpacing: "-0.5px",
            }}
          >
            Home Dashboard
          </h1>
          <p
            style={{
              fontSize: "13px",
              color: "#64748b",
              margin: "2px 0 0",
              fontWeight: "500",
            }}
          >
            Welcome back! Here's your overview.
          </p>
        </div>

        <div
          style={{
            background: "#ffffff",
            borderRadius: "10px",
            padding: "8px 14px",
            fontSize: "12px",
            fontWeight: "600",
            color: "#1e5799",
            border: "1.5px solid #c7ddf3",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            boxShadow: "0 2px 8px rgba(30, 87, 153, 0.06)",
          }}
        >
          📅 {new Date().toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
        </div>
      </div>

      {/* 🎯 STAT CARDS — Graphical (No Data) */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: "14px",
          flexShrink: 0,
        }}
      >
        {[
          { icon: "🏢", color: "#1e5799" },
          { icon: "👥", color: "#2b6cb0" },
          { icon: "₹", color: "#059669" },      // 👈 Rupee symbol
          { icon: "📝", color: "#7c3aed" },
        ].map((card, i) => (
          <div
            key={i}
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              padding: "16px",
              border: "1.5px solid #e2e8f0",
              boxShadow: "0 4px 14px rgba(30, 87, 153, 0.06)",
              transition: "all 0.3s ease",
              cursor: "pointer",
              position: "relative",
              overflow: "hidden",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)";
              e.currentTarget.style.boxShadow = "0 12px 28px rgba(30, 87, 153, 0.15)";
              e.currentTarget.style.borderColor = card.color;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 4px 14px rgba(30, 87, 153, 0.06)";
              e.currentTarget.style.borderColor = "#e2e8f0";
            }}
          >
            {/* Colored accent bar */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "4px",
                height: "100%",
                background: card.color,
              }}
            />

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <div style={{ flex: 1 }}>
                {/* Skeleton label */}
                <div
                  style={{
                    width: "60%",
                    height: "9px",
                    borderRadius: "6px",
                    background: "#e2e8f0",
                    marginBottom: "10px",
                  }}
                />
                {/* Skeleton value */}
                <div
                  style={{
                    width: "80%",
                    height: "22px",
                    borderRadius: "6px",
                    background: "linear-gradient(90deg, #e2e8f0, #f1f5f9, #e2e8f0)",
                    backgroundSize: "200% 100%",
                    animation: "shimmer 2s infinite",
                    marginBottom: "10px",
                  }}
                />
                {/* Skeleton pill */}
                <div
                  style={{
                    width: "50px",
                    height: "16px",
                    borderRadius: "20px",
                    background: `${card.color}22`,
                    border: `1px solid ${card.color}44`,
                  }}
                />
              </div>

              <div
                style={{
                  width: "42px",
                  height: "42px",
                  borderRadius: "12px",
                  background: `linear-gradient(135deg, ${card.color}, ${card.color}dd)`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "20px",
                  boxShadow: `0 6px 16px ${card.color}33`,
                  flexShrink: 0,
                }}
              >
                {card.icon}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* 🎯 MAIN CONTENT GRID */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "2fr 1fr",
          gap: "14px",
          flex: 1,
          minHeight: 0,
        }}
      >
        {/* LEFT */}
        <div style={{ display: "flex", flexDirection: "column", gap: "14px", minHeight: 0 }}>
          {/* Progress Bars Card */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              padding: "18px",
              border: "1.5px solid #e2e8f0",
              boxShadow: "0 4px 14px rgba(30, 87, 153, 0.06)",
              flex: 1,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "16px",
                flexShrink: 0,
              }}
            >
              <h3
                style={{
                  fontSize: "15px",
                  fontWeight: "700",
                  color: "#1e3a5f",
                  margin: 0,
                }}
              >
                📊 Progress Overview
              </h3>
              <span
                style={{
                  fontSize: "11px",
                  color: "#1e5799",
                  fontWeight: "700",
                  cursor: "pointer",
                }}
              >
                View All →
              </span>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: "18px", flex: 1, justifyContent: "center" }}>
              {[78, 62, 45, 92].map((width, i) => (
                <div key={i}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "8px",
                    }}
                  >
                    <div
                      style={{
                        width: "35%",
                        height: "11px",
                        borderRadius: "6px",
                        background: "#e2e8f0",
                      }}
                    />
                    <div
                      style={{
                        width: "30px",
                        height: "11px",
                        borderRadius: "6px",
                        background: `${["#1e5799", "#2b6cb0", "#059669", "#7c3aed"][i]}33`,
                      }}
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      height: "10px",
                      background: "#f1f5f9",
                      borderRadius: "10px",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        width: `${width}%`,
                        height: "100%",
                        background: `linear-gradient(90deg, ${["#1e5799", "#2b6cb0", "#059669", "#7c3aed"][i]}, ${["#1e5799", "#2b6cb0", "#059669", "#7c3aed"][i]}cc)`,
                        borderRadius: "10px",
                        animation: "growBar 1.5s ease",
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Activity List — Skeleton */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              padding: "18px",
              border: "1.5px solid #e2e8f0",
              boxShadow: "0 4px 14px rgba(30, 87, 153, 0.06)",
              flex: 1,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "14px",
                flexShrink: 0,
              }}
            >
              <h3
                style={{
                  fontSize: "15px",
                  fontWeight: "700",
                  color: "#1e3a5f",
                  margin: 0,
                }}
              >
                🔔 Recent Activity
              </h3>
              <span
                style={{
                  fontSize: "11px",
                  color: "#1e5799",
                  fontWeight: "700",
                  cursor: "pointer",
                }}
              >
                View All →
              </span>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                flex: 1,
                justifyContent: "center",
              }}
            >
              {[1, 2, 3, 4].map((_, i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    padding: "10px 12px",
                    borderRadius: "10px",
                    background: "#f8fafc",
                    transition: "all 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#e8f1fb";
                    e.currentTarget.style.transform = "translateX(4px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "#f8fafc";
                    e.currentTarget.style.transform = "translateX(0)";
                  }}
                >
                  {/* Icon Skeleton */}
                  <div
                    style={{
                      width: "34px",
                      height: "34px",
                      borderRadius: "50%",
                      background: `${["#1e5799", "#059669", "#f59e0b", "#dc2626"][i]}22`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "14px",
                      flexShrink: 0,
                    }}
                  >
                    {["🏢", "✅", "⚠️", "📩"][i]}
                  </div>

                  {/* Text Skeleton */}
                  <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "6px" }}>
                    <div
                      style={{
                        width: `${75 - i * 8}%`,
                        height: "10px",
                        borderRadius: "6px",
                        background: "#e2e8f0",
                      }}
                    />
                    <div
                      style={{
                        width: `${50 - i * 5}%`,
                        height: "8px",
                        borderRadius: "6px",
                        background: "#f1f5f9",
                      }}
                    />
                  </div>

                  {/* Time Skeleton */}
                  <div
                    style={{
                      width: "36px",
                      height: "9px",
                      borderRadius: "6px",
                      background: "#e2e8f0",
                      flexShrink: 0,
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* RIGHT */}
        <div style={{ display: "flex", flexDirection: "column", gap: "14px", minHeight: 0 }}>
          {/* Revenue Chart — Bar Chart */}
          <div
            style={{
              background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
              borderRadius: "16px",
              padding: "18px",
              boxShadow: "0 8px 24px rgba(30, 87, 153, 0.25)",
              flex: 1,
              display: "flex",
              flexDirection: "column",
              color: "#ffffff",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Decorative Glow */}
            <div
              style={{
                position: "absolute",
                top: "-60px",
                right: "-60px",
                width: "160px",
                height: "160px",
                borderRadius: "50%",
                background: "radial-gradient(circle, rgba(255,255,255,0.15) 0%, transparent 70%)",
                pointerEvents: "none",
              }}
            />

            <h3
              style={{
                fontSize: "14px",
                fontWeight: "700",
                margin: "0 0 4px",
                opacity: 0.95,
              }}
            >
              📈 Revenue Trend
            </h3>
            <p style={{ fontSize: "11px", margin: "0 0 16px", opacity: 0.75 }}>
              Last 6 months
            </p>

            {/* Bar Chart */}
            <div
              style={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "space-between",
                gap: "8px",
                flex: 1,
                paddingBottom: "4px",
              }}
            >
              {[45, 62, 38, 78, 55, 92].map((val, i) => (
                <div
                  key={i}
                  style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "6px",
                    height: "100%",
                    justifyContent: "flex-end",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: `${val}%`,
                      background: "linear-gradient(180deg, #ffffff, rgba(255,255,255,0.4))",
                      borderRadius: "6px 6px 2px 2px",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                      minHeight: "10px",
                      animation: `growBar${i} 1s ease`,
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = "#ffffff";
                      e.currentTarget.style.transform = "scaleY(1.05)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "linear-gradient(180deg, #ffffff, rgba(255,255,255,0.4))";
                      e.currentTarget.style.transform = "scaleY(1)";
                    }}
                  />
                  <div
                    style={{
                      width: "60%",
                      height: "8px",
                      borderRadius: "6px",
                      background: "rgba(255,255,255,0.4)",
                    }}
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Donut Chart Card */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              padding: "18px",
              border: "1.5px solid #e2e8f0",
              boxShadow: "0 4px 14px rgba(30, 87, 153, 0.06)",
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "12px",
            }}
          >
            <h3
              style={{
                fontSize: "14px",
                fontWeight: "700",
                color: "#1e3a5f",
                margin: 0,
                alignSelf: "flex-start",
              }}
            >
              🎯 Distribution
            </h3>

            {/* Donut Chart */}
            <div
              style={{
                position: "relative",
                width: "130px",
                height: "130px",
                margin: "auto",
              }}
            >
              <svg width="130" height="130" viewBox="0 0 130 130">
                <circle
                  cx="65"
                  cy="65"
                  r="50"
                  fill="none"
                  stroke="#e2e8f0"
                  strokeWidth="14"
                />
                <circle
                  cx="65"
                  cy="65"
                  r="50"
                  fill="none"
                  stroke="#1e5799"
                  strokeWidth="14"
                  strokeDasharray="188 314"
                  strokeDashoffset="0"
                  strokeLinecap="round"
                  transform="rotate(-90 65 65)"
                  style={{ animation: "drawDonut 1.5s ease" }}
                />
                <circle
                  cx="65"
                  cy="65"
                  r="50"
                  fill="none"
                  stroke="#2b6cb0"
                  strokeWidth="14"
                  strokeDasharray="95 314"
                  strokeDashoffset="-188"
                  strokeLinecap="round"
                  transform="rotate(-90 65 65)"
                  style={{ animation: "drawDonut 1.5s ease" }}
                />
                <circle
                  cx="65"
                  cy="65"
                  r="50"
                  fill="none"
                  stroke="#059669"
                  strokeWidth="14"
                  strokeDasharray="31 314"
                  strokeDashoffset="-283"
                  strokeLinecap="round"
                  transform="rotate(-90 65 65)"
                  style={{ animation: "drawDonut 1.5s ease" }}
                />
              </svg>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    width: "36px",
                    height: "10px",
                    borderRadius: "6px",
                    background: "#e2e8f0",
                    margin: "0 auto 6px",
                  }}
                />
                <div
                  style={{
                    width: "52px",
                    height: "16px",
                    borderRadius: "6px",
                    background: "linear-gradient(90deg, #e2e8f0, #f1f5f9, #e2e8f0)",
                    backgroundSize: "200% 100%",
                    animation: "shimmer 2s infinite",
                    margin: "0 auto",
                  }}
                />
              </div>
            </div>

            {/* Legend */}
            <div
              style={{
                display: "flex",
                gap: "12px",
                justifyContent: "center",
                flexWrap: "wrap",
                marginTop: "4px",
              }}
            >
              {[
                { color: "#1e5799", label: "60%" },
                { color: "#2b6cb0", label: "30%" },
                { color: "#059669", label: "10%" },
              ].map((item, i) => (
                <div
                  key={i}
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <div
                    style={{
                      width: "9px",
                      height: "9px",
                      borderRadius: "50%",
                      background: item.color,
                    }}
                  />
                  <span
                    style={{
                      fontSize: "10.5px",
                      fontWeight: "700",
                      color: "#64748b",
                    }}
                  >
                    {item.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* 🎨 Animations */}
      <style>{`
        @keyframes shimmer {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
        @keyframes growBar {
          from { width: 0; }
        }
        @keyframes drawDonut {
          from { stroke-dasharray: 0 314; }
        }
      `}</style>
    </div>
  );
};

export default HomeDashboard;